const Href = ({ href, children, className = 'bold underline', target = '_blank', rel = 'noopener noreferrer' }) => {
  return (
    <a href={href} target={target} rel={rel} className={className}>
      {children}
    </a>
  )
}

export default Href
